export enum BikeStatusToSet {
  ACTIVATE = 'Activate',
  DISABLE = 'Disable',
}
